import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import BaseSearchResults, {
  BaseSearchResultsProps,
} from 'pages/searchPage/baseSearchResults';
import BlockHeader from 'pages/components/blockHeader';
import SortingControl, {
  SortingValue,
} from 'shared/lib/components/controls/sorting/sortingControl';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export type OtherSearchResultsProps = {
  sort: SortingValue;
  onSortingChange: (val: SortingValue) => void;
  isOther: boolean;
  amount: number;
} & BaseSearchResultsProps;

export default observer(function CommonSearchResults({
  results,
  onSortingChange,
  sort,
  isOther,
  amount,
}: OtherSearchResultsProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const { isLessLaptop } = useBooleanScreens();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: sp.s80 }}>
      <BlockHeader
        text={isOther ? 'Прочие результаты:' : 'Найдено совпадений:'}
        secondText={`${amount}`}
        buttonsNode={
          <SortingControl
            value={sort}
            onChange={onSortingChange}
            sx={{ width: 290, alignSelf: isLessLaptop ? 'start' : 'end' }}
          ></SortingControl>
        }
      ></BlockHeader>
      <BaseSearchResults sort={sort} results={results}></BaseSearchResults>
    </Box>
  );
});
